import { createContext } from 'react'

export const MemberApplicationContext = createContext(null);

